import { create } from 'zustand';

type RatingPromptState = {
  isPromptVisible: boolean;
  sessionAttempted: boolean;
  sessionUserId: string | null;
};

type RatingPromptActions = {
  openPrompt: () => void;
  closePrompt: () => void;
  markSessionAttempted: () => void;
  syncSessionUser: (userId: string) => void;
  resetSession: () => void;
};

const initialState: RatingPromptState = {
  isPromptVisible: false,
  sessionAttempted: false,
  sessionUserId: null,
};

export const useRatingPromptStore = create<RatingPromptState & RatingPromptActions>((set) => ({
  ...initialState,
  openPrompt: () => set(() => ({ isPromptVisible: true })),
  closePrompt: () => set(() => ({ isPromptVisible: false })),
  markSessionAttempted: () => set(() => ({ sessionAttempted: true })),
  syncSessionUser: (userId) =>
    set((state) => {
      if (state.sessionUserId === userId) return {};
      return {
        sessionUserId: userId,
        sessionAttempted: false,
        isPromptVisible: false,
      };
    }),
  resetSession: () =>
    set(() => ({
      ...initialState,
    })),
}));
